<template>
  <div class="news-detail">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <!-- pc端 -->
    <section class="news-detail-center" v-if="data">
      <Breadcrumb :fromPath="fromPath" />
      <div class="news-detail-center-top">
        <div class="news-detail-center-top-left">
          <img
            :src="data.img"
            alt=""
          />
        </div>
        <div class="news-detail-center-top-right">
          <div class="classify" v-if="data.categorys">
            <div class="title">相关新闻分类</div>
            <ul>
              <li v-for="category in data.categorys.split(',')" :key="category" @click="gotoList('categorys', category)">{{ category }}</li>
            </ul>
          </div>
          <div class="tag" v-if="data.tags">
            <div class="title">新闻标签</div>
            <ul>
              <li v-for="tag in data.tags.split(',')" :key="tag" @click="gotoList('tag', tag)">{{ tag }}</li>
            </ul>
          </div>
          <div class="classify" v-if="data.attachments.length > 0">
            <div class="title">附件</div>
            <ul>
               <li v-for="item in data.attachments" :key="item.id"  @click="gotourl(item.url)"> {{ item.title || item.filename }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="news-detail-center-content">
        <div class="title">
          {{ data.title }}
        </div>
        <div class="author">
          <div>作者：</div>
          <div>{{ data.author ?data.author: '中田认证' }}</div>
          <div class="author-date">发布于：</div>
          <div>{{ moment(data.createdate).format('YYYY-MM-DD HH:mm:ss') }}</div>
          <div class="author-number">浏览（{{ data.pvCount?data.pvCount:1 }}）</div>
        </div>
        <div class="article-content message" v-html="data.content"></div>
        <!--
<iframe  @load="frm"  id="article-box" frameborder=0 name="showhere" scrolling=auto src="" :height="contentHeight" width="100%"></iframe>
-->
      </div>
    </section>
    <!-- 移动端 -->
    <section class="news-detail-center-mobile" v-if="data">
      <div class="content">
        <div class="title">
          {{ data.title }}
        </div>
        <div class="author-wrap">
          <div class="left tag-list" v-if="data.tags"> 
            <span v-for="tag in data.tags.split(',')" :key="tag" class="tag-item" @click="gotoList('tag', tag)">{{ tag }}</span>
          </div>
          <div class="right">
            <template  v-if="data.author">
            <div class="author">作者：{{ data.author ?data.author: '中田认证'  }}</div>
            </template>
            <div>
              <span class="number">{{ data.pvCount?data.pvCount:1 }}次浏览</span>
              <span class="date">{{ moment(data.createdate).format('YYYY-MM-DD') }}</span>
            </div>
          </div>
        </div>
        <img
          :src="data.img"
          class="content-img"
        />
        <div class="message article-content" v-html="data.content">
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>
<script>
import headerCmp from "@/components/common/header.vue";
import menuCmp from "@/components/common/navMenu.vue";
import footerCmp from "@/components/common/footer.vue";
import Breadcrumb from "./components/Breadcrumb.vue";
import { getNewsDetail } from "@/api/news.js";
import moment from "moment";
import "@/assets/style/detail-reset.scss";
export default {
  data() {
    return {
      newsId: this.$route.query.id,
      fromPath: "",
      data: null,
      contentHeight:2000,
    };
  },
  components: {
    headerCmp,
    menuCmp,
    footerCmp,
    Breadcrumb,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path;
    });
  },
  methods: {
    moment,
    getDetail(){
      getNewsDetail({ id: this.newsId }).then(res=>{
        this.data = res.data;
        // this.frm();
      })
    },
    gotoList(type, val){
      this.$router.push(`/more?type=${type}&val=${val}`);
    },
    gotourl(url){
            window.open(url);
        },
      //   frm(){
	    //   let iframeBox=document.getElementById("article-box");
	    //   let _obj=iframeBox.contentWindow || iframeBox.contentDocument;
	    //   let doc=_obj.document;
      //    //iframeBox.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
      //     doc.body.innerHTML = this.data.content;
      //     _obj.height = doc.body.scrollHeight;
      //     this.contentHeight = doc.body.scrollHeight       

         
    
    	// },

  },
  watch: {
      $route() {
          this.newsId = this.$route.query.id;
          this.getDetail();
          this.getList();
      }
  },
  mounted(){ 
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 961px) {
  .news-detail {
    font-size: 14px;
    width: 100%;
    height: 100%;

    &-center {
      width: 1200px;
      margin: 0 auto;

      &-top {
        margin-bottom: 24px;
        display: flex;

        &-left {
          img {
            width: 790px;
            height: 427px;
            margin-right: 40px;
          }
        }

        &-right {
          .classify {
            .title {
              font-size: 24px;
              font-weight: 500;
              color: #da5351;
              line-height: 33px;
              margin-bottom: 20px;
            }

            ul {
              margin-bottom: 24px;

              li {
                cursor: pointer;
                &::before {
                  content: "> ";
                }

                font-size: 16px;
                font-weight: 500;
                color: #333333;
                line-height: 22px;
                margin-bottom: 16px;
              }
            }
          }

          .tag {
            .title {
              font-weight: 500;
              color: #da5351;
              line-height: 33px;
              margin-bottom: 20px;
              font-size: 24px;
            }

            ul {
              display: flex;
              flex-wrap: wrap;

              li {
                padding: 8px 14px;
                cursor: pointer;
                border-radius: 30px;
                border: 1px solid #da5351;
                font-size: 14px;
                font-weight: 400;
                color: #da5351;
                text-align: center;
                margin-right: 10px;
                margin-bottom: 12px;
                max-width: 140px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }

      &-content {
        width: 790px;

        .title {
          font-size: 34px;
          font-weight: 500;
          color: #333333;
          line-height: 46px;
          margin: 24px 0px 20px 0px;
          //white-space: nowrap;
          overflow: hidden;
          //text-overflow: ellipsis;
        }

        .author {
          display: flex;
          margin-bottom: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;

          &-date {
            margin-left: 10px;
          }

          &-number {
            margin-left: 10px;
          }
        }

        .message {
          // font-size: 16px;
          // font-weight: 400;
          // color: #454545;
          // line-height: 24px;
          margin-bottom: 80px;
        }
      }
    }
  }

  .news-detail-center-mobile {
    display: none;
  }
}

@media screen and (max-width: 960px) {
  .news-detail-center {
    display: none;
  }

  .news-detail-center-mobile {
    height: 100%;
    position: relative;
    padding-top: 0.56rem;
    .content {
      padding: 0.24rem 0.16rem 0.4rem;
      min-height: calc(100vh - var(--nav-menu-height) - var(--foot-height));
      box-sizing: border-box;
    }
    .title {
      font-size: 0.24rem;
      font-weight: 500;
      color: #454545;
      line-height: 0.3rem;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .author-wrap {
      margin: 0.1rem 0px 0.16rem;
      .left {
        font-size: 0.12rem;
        font-weight: 500;
      }
      .tag-item{
        display: inline-block;
        color: #cc3b3f;
        line-height: 0.16rem;
        padding: 0.04rem 0.1rem;
        background: rgba($color: #cc3b3f, $alpha: 0.2);
        border-radius: 0.04rem;
        margin-right: .1rem;
        margin-bottom: .1rem
      }
      .right {
        display: flex;
        font-size: 0.12rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.14rem;
        justify-content: space-between;
        .number {
          margin-right:  .1rem;
          display: inline-block;
        }
      }
    }
    .content-img {
      width: 100%;
      height: 1.67rem;
      object-fit: cover;
    }
    .message {
      // font-size: 0.16rem;
      // font-weight: 400;
      // color: #454545;
      // line-height: 0.22rem;
      // ::v-deep{
      // img{
      //     max-width: 100%;    
      //     object-fit: contain;
      //     height: auto;
      //   }
      // }
    }
  }
}
</style>